import { CalculatorCarConsumptionFormValidation } from '@tmh-website/components/shared/CalculatorCarConsumption/validation';
import Yup from '@tmh-website/services/validation.service';

export const PowerConsumptionShared = Yup.object({
  carConsumption: Yup.number().min(0).required(),
  homeConnectionHours: Yup.number().min(0).required(),
  calculatorCarConsumptionValues: CalculatorCarConsumptionFormValidation.nullable().notRequired(),
});

export const TariffInfoShared = Yup.object({
  tariffId: Yup.number().positive().required(),
  isSmartMeterTariff: Yup.boolean().required(),
  tariffPopupConfirmation: Yup.boolean().required(),
});

export const UserDataShared = Yup.object({
  firstName: Yup.string().max(70).required(),
  lastName: Yup.string().max(70).required(),
  street: Yup.string().max(70).required(),
  differentBillingAddress: Yup.boolean().required(),
  billingFirstName: Yup.mixed().when('differentBillingAddress', {
    is: true,
    then: Yup.string().max(70).required(),
  }),
  billingLastName: Yup.mixed().when('differentBillingAddress', {
    is: true,
    then: Yup.string().max(70).required(),
  }),
  billingZipCode: Yup.mixed().when('differentBillingAddress', {
    is: true,
    then: Yup.string()
      .matches(/^\d{5}$/, 'Ungültiges Format')
      .required(),
  }),
  billingCity: Yup.mixed().when('differentBillingAddress', {
    is: true,
    then: Yup.string().max(35).required(),
  }),
  email: Yup.string().email().required(),
  /**
   * Id coming from SSO login process, auto-set, cannot be changed via user
   */
  personId: Yup.string(),
});

export const ReviewShared = Yup.object({
  acceptAdvertising: Yup.boolean(),
});
